import * as React from "react";
import { Grid, Typography } from "@mui/material";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { LoginPageStyles } from "./loginPageStyles";
import { useLogin } from "./login.hooks";
import { LoginCardHeader } from "./components/loginCardHeader/loginCardHeader.index";
import { SsoLoginSection } from "./components/ssoLoginSection/ssoLoginSection.index";
import { EmailLoginStep } from "./components/emailLoginStep/emailLoginStep.index";
import { OtpLoginStep } from "./components/otpLoginStep/otpLoginStep.index";
import { LoginFormActions } from "./components/loginFormActions/loginFormActions.index";

const Login: React.FC = () => {
    const { classes } = LoginPageStyles();
    const login = useLogin();

    const {
        mainOuterCtn,
        mainBlockCtn,
        mainBlock,
        signInBox,
        cardHeader,
        logoInCard,
        heading,
        subheading,
        signInButton,
        btnCtn,
        logoImg,
        dividerWrapper,
        orDividerLabel,
        formFieldsSection,
        errorText,
        emailTextField,
        emailSignInBtn,
        spinner,
        resendSpinner,
        otpHint,
        otpInputWrapper,
        otpFieldError,
        textActionButton,
        resendOtpButton,
        formBusy,
    } = classes;

    return (
        <Grid container className={mainOuterCtn}>
            <Header width="100%" showLogo={true} showEnv={false} height={"93px"} />

            <Grid item className={mainBlockCtn}>
                <Grid container className={mainBlock}>
                    <Grid item className={signInBox}>
                        <LoginCardHeader
                            subheading={login.subheadingText}
                            cardHeaderClass={cardHeader}
                            logoInCardClass={logoInCard}
                            headingClass={heading}
                            subheadingClass={subheading}
                        />

                        <Grid
                            container
                            direction="column"
                            alignItems="center"
                            className={login.isFormBusy ? formBusy : undefined}
                            aria-busy={login.isFormBusy}
                        >
                            {login.loginStep === "email" && (
                                <SsoLoginSection
                                    onGoogleSignIn={() => login.handleSignInWithGoogle()}
                                    disabled={login.isFormBusy}
                                    btnCtnClass={btnCtn}
                                    signInButtonClass={signInButton}
                                    logoImgClass={logoImg}
                                    dividerWrapperClass={dividerWrapper}
                                    orDividerLabelClass={orDividerLabel}
                                />
                            )}

                            <Grid item className={formFieldsSection}>
                                {login.loginStep === "email" && login.formErrors.general && (
                                    <Typography className={errorText}>
                                        {login.formErrors.general}
                                    </Typography>
                                )}

                                {login.loginStep === "email" ? (
                                    <EmailLoginStep
                                        email={login.email}
                                        formErrors={login.formErrors}
                                        disabled={login.isFormBusy}
                                        emailTextFieldClass={emailTextField}
                                        onEmailChange={login.setEmail}
                                        onClearEmailError={() => login.clearFieldError("email")}
                                        onKeyDown={login.handleKeyDown}
                                    />
                                ) : (
                                    <OtpLoginStep
                                        email={login.email}
                                        otp={login.otp}
                                        otpFieldKey={login.otpFieldKey}
                                        formErrors={login.formErrors}
                                        isSubmitting={login.isFormBusy}
                                        otpHintClass={otpHint}
                                        otpInputWrapperClass={otpInputWrapper}
                                        otpFieldErrorClass={otpFieldError}
                                        onOtpChange={login.handleOtpChange}
                                        onClearOtpError={() => login.clearFieldError("otp")}
                                        onEnterSubmit={login.handlePrimaryAction}
                                    />
                                )}

                                <LoginFormActions
                                    primaryLabel={login.primaryButtonLabel}
                                    isPrimarySubmitting={login.isPrimarySubmitting}
                                    isResendingOtp={login.isResendingOtp}
                                    isPrimaryDisabled={login.isPrimaryDisabled}
                                    onPrimaryAction={login.handlePrimaryAction}
                                    emailSignInBtnClass={emailSignInBtn}
                                    spinnerClass={spinner}
                                    resendSpinnerClass={resendSpinner}
                                    showOtpActions={login.loginStep === "otp"}
                                    resendCooldownSec={login.resendCooldownSec}
                                    resendCooldownLabel={login.resendCooldownLabel}
                                    onResendOtp={login.handleResendOtp}
                                    onBackToEmail={login.handleBackToEmail}
                                    resendOtpButtonClass={resendOtpButton}
                                    textActionButtonClass={textActionButton}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Footer />
        </Grid>
    );
};

export default Login;
